// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Rik","colBig":"styles_colBig__1TC_W","colSmall":"styles_colSmall__1QFCt"};